import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-oib-service-dialog',
  templateUrl: './oib-service-dialog.component.html'
})
export class OibServiceDialogComponent {
  @Input() showDialog = false;
  @Input() loadingOib = false;
  @Input() oib!: FormControl<string | null>;
  @Input() oibReadonly = false;
  @Input() dirty = false;
  @Input() oibResponse: any = null;
  @Input() fetchError: any = null;
  @Input() applyError: any = null;

  @Output() showDialogChange = new EventEmitter<boolean>();
  @Output() searchClicked = new EventEmitter<void>();
  @Output() applyClicked = new EventEmitter<void>();
  @Output() closeClicked = new EventEmitter<void>();

  onClose() {
    this.closeClicked.emit();
    this.showDialogChange.emit(false);
  }
}
